import { useFormContext } from 'react-hook-form';
import { ZodError } from 'zod';

export function useCheckFormSchema(args: UseCheckFormSchemaArgs) {
  const { name } = args;
  const { schema } = useFormContext();

  if (!schema.shape[name]) throw new ZodError(`Missing key '${name}' from validation schema passed in Form component.`);
}

interface UseCheckFormSchemaArgs {
  name: string;
}